import { FormInput } from 'components/FormInput/FormInput';
import { FormLayout } from 'layouts/FormLayout/FormLayout';
import { validateInput } from 'functions/validationUtils';
import { trimInputValue } from 'functions/trimInputValue';
import { useAppSettings } from 'context/appsettingsContext';
import { useNavigate } from 'react-router-dom';
import Button from 'components/Button/Button';
import FormRow from 'components/FormRow/FormRow';
import React, { useState } from 'react';
import { useCollection } from 'functions/hooks/useCollection';
import { Timestamp } from 'firebase/firestore';

export default function AddCompany() {
  const navigate = useNavigate();
  const settings = useAppSettings();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const companiesCollection = useCollection<any>('companies');
  const isRSARegion = settings.firebaseProjectId.toLowerCase().endsWith('rsa') || settings.firebaseProjectId.toLowerCase().endsWith('rsa-stg');
  const isUSARegion = settings.firebaseProjectId.toLowerCase().endsWith('usa') || settings.firebaseProjectId.toLowerCase().endsWith('usa-stg');

  const [formData, setFormData] = useState({
    CompanyName: '',
  });

  const [formErrors, setFormErrors] = useState({
    CompanyName: [],
  });

  function handleOnChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { id, value } = e.target;
    const inputValue = trimInputValue(id, value);
    
    setFormData((prevState) => ({
      ...prevState,
      [id]: inputValue,
    }));
  }

  function handleInputValidation(e: React.ChangeEvent<HTMLInputElement>) {
    const { id, value } = e.target;
    setFormErrors((prevState) => ({
      ...prevState,
      [id]: validateInput(id, value, isRSARegion, isUSARegion, false),
    }));
  }

  async function handleSubmit() {
    
    setIsSubmitting(true);

    try {
      
      const now = Timestamp.now();

      const companyId = await companiesCollection.insertOne({
        audit: {
          createdAt: now,
          updatedAt: now
        },
        details: {
          name: formData.CompanyName
        }
      });

      navigate(`/agent/companies/${companyId}/link-user`);
      
    } catch (error: any) {

      alert('Failed: ' + error.message);
      
      //if (axios.isAxiosError(error)) {
      //  setFormErrors(error.response?.data.errors);
      //}

    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <FormLayout>
      <FormLayout.Header>
        <FormLayout.HeaderClose linkPath='/' />
        <p>Add Company</p>
      </FormLayout.Header>
      <FormLayout.Main>
        <FormRow>
          <FormInput
            id='CompanyName'
            label='Name'
            onChange={handleOnChange}
            value={formData.CompanyName}
            onBlur={handleInputValidation}
            errorMessage={formErrors.CompanyName}
          />
        </FormRow>
      </FormLayout.Main>
      <FormLayout.Footer>
        <Button
          label={isSubmitting ? 'Submitting' : 'Add Company'}
          fullWidth
          onClick={handleSubmit}
          disabled={
            !formData.CompanyName ||
            isSubmitting
          }
        />
      </FormLayout.Footer>
    </FormLayout>
  );
}